import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/InviteCode/inviteCodeCopy";

/**
 * 邀请码相关文案 —— 走 scoped I18n，对齐 `signInPageCopy` 的形态。
 *
 * 用户可见文案统一叫 "invite code"（PRD 0.5，EDG-557 起不再叫 referral code），
 * 代码标识符也统一 `invite`（后端 `OS-Invite-Code`）。
 * 文案来源：Figma `110013:130019` / `130031` / `130291`（填码弹层与入口行）。
 */
export function createInviteCodeCopy(locale?: string) {
  const I18n = I18nUtil.createScoped(Translations, locale);
  return {
    /** 入口行（无码）与弹层标题 */
    haveACode: I18n.t("Have an invite code?"),
    /** 弹层说明 */
    subtitle: I18n.t(
      "Enter it to link up with the friend who invited you. You can skip this.",
    ),
    /** 输入框占位 */
    placeholder: I18n.t("Enter invite code"),
    /** 主按钮 */
    applyCode: I18n.t("Apply code"),
    /** 次按钮：只关闭，不改任何状态 */
    close: I18n.t("Close"),
    /** 格式非法 / 后端不认这个码 */
    invalidCode: I18n.t(
      "That code doesn't match an invite. Check it, or skip and keep going.",
    ),
    /** 已应用行：`✓ Invite code ` + <code> + ` applied`（code 段加下划线） */
    appliedPrefix: I18n.t("✓ Invite code "),
    appliedSuffix: I18n.t(" applied"),
  } as const;
}

export type InviteCodeCopy = ReturnType<typeof createInviteCodeCopy>;

/** 默认（英文）实例，供无 locale 上下文的调用方与测试使用。 */
export const INVITE_CODE_COPY = createInviteCodeCopy();
